export const status = {
  success: 'success',
  error: 'error'
}

export const reason = {
  roomsNotAvailable: 'ROOMS_NOT_AVAILABLE'
}



// WEBPACK FOOTER //
// ./src/constants/apiConstants.js